<template>
  <!-- 传播表现 -->
  <div class="ExpressionContainer">
    <!-- <el-tabs v-model="portraitName" @tab-click="expressionTabClick">
      <el-tab-pane label="个人视频" name="个人视频"></el-tab-pane>
      <el-tab-pane label="聚星视频" name="聚星视频"></el-tab-pane>
    </el-tabs> -->
    <div v-loading="loadingObj.worksinfo" class="part1">
      <div class="top-wrap">
        <h4>数据概览</h4>
        <div>
          <el-radio-group v-model="daysTab">
            <el-radio-button label="30">30天</el-radio-button>
            <el-radio-button label="90">90天</el-radio-button>
          </el-radio-group>
          <el-radio-group v-model="portraitName1" @change="e=>{expressionTabClick(e,1)}" style="margin-left:10px">
            <el-radio-button label="个人视频">个人视频</el-radio-button>
            <el-radio-button label="聚星视频">聚星视频</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <ul class="clear">
          <li>
              <p>
                完播率
                <el-tooltip effect="dark" :content="portraitName1.includes('个人') ? '达人近期发布的视频中，被完整播放的概率，仅统计7日自然流量的数据' : '达人近期已结算的视频中，被完整播放的概率，仅统计履约期间自然流量'" placement="bottom">
                  <img src="../../../assets/question.png" class="question" alt="">
                </el-tooltip>
              </p>
              <span v-show="portraitName1==='个人视频'">{{darenWorksinfo.starWorkReport.pcompletePlayRate?darenWorksinfo.starWorkReport.pcompletePlayRate:"-"}}<i class="rank" v-if="darenInfo.pvideoCompleteShowTag">{{darenInfo.pvideoCompleteShowTag}}</i></span>
              <span v-show="portraitName1==='聚星视频'">{{darenWorksinfo.starWorkReport.bcompletePlayRate?darenWorksinfo.starWorkReport.bcompletePlayRate:"-"}}<i class="rank" v-if="darenInfo.bvideoCompleteShowTag">{{darenInfo.bvideoCompleteShowTag}}</i></span>
              <p v-show="portraitName1==='个人视频'">超过<span class="colorRed">{{darenWorksinfo.starWorkReport?.pcompletePlayExceedRateData?.[daysTab]? fmt(darenWorksinfo.starWorkReport.pcompletePlayExceedRateData?.[daysTab]*100):'-'}}%</span>同类型达人</p>
              <p v-show="portraitName1==='聚星视频'">超过<span class="colorRed">{{darenWorksinfo.starWorkReport?.bcompletePlayExceedRateData?.[daysTab]? fmt(darenWorksinfo.starWorkReport?.bcompletePlayExceedRateData?.[daysTab]*100):'-'}}%</span>同类型达人</p>
          </li>
          <li>
              <p>
                互动率
                <el-tooltip effect="dark" :content="portraitName1.includes('个人') ? '达人近期发布的视频中，被点赞、评论、分享的概率，仅统计7日自然流量的数据' : '达人近期已结算的视频中，被点赞、评论、分享的概率，仅统计履约期间自然流量'" placement="bottom">
                  <img src="../../../assets/question.png" class="question" alt="">
                </el-tooltip>
              </p>
              <span v-show="portraitName1==='个人视频'">{{darenWorksinfo.starWorkReport.pinteractionRate?darenWorksinfo.starWorkReport.pinteractionRate:"-"}}<i class="rank" v-if="darenInfo.pvideoInteractiveShowTag">{{darenInfo.pvideoInteractiveShowTag}}</i></span>
              <span v-show="portraitName1==='聚星视频'">{{darenWorksinfo.starWorkReport.binteractionRate?darenWorksinfo.starWorkReport.binteractionRate:"-"}}<i class="rank" v-if="darenInfo.bvideoInteractiveShowTag">{{darenInfo.bvideoInteractiveShowTag}}</i></span>
              <p v-show="portraitName1==='个人视频'">超过<span class="colorRed">{{darenWorksinfo.starWorkReport.pinteractionExceedRateData?.[daysTab]? fmt(darenWorksinfo.starWorkReport.pinteractionExceedRateData?.[daysTab]*100):'-'}}%</span>同类型达人</p>
              <p v-show="portraitName1==='聚星视频'">超过<span class="colorRed">{{darenWorksinfo.starWorkReport.binteractionExceedRateData?.[daysTab]? fmt(darenWorksinfo.starWorkReport.binteractionExceedRateData?.[daysTab]*100):'-'}}%</span>同类型达人</p>
            </li>
          <li>
              <p>
                播放量中位数
                <el-tooltip effect="dark" :content="portraitName1.includes('个人') ? '达人近期发布的视频中，处于中位数水平的自然流量7日播放量' : '达人近期已结算的视频中，处于中位数水平的履约期间自然流量播放量'" placement="bottom">
                  <img src="../../../assets/question.png" class="question" alt="">
                </el-tooltip>
              </p>
              <span v-show="portraitName1==='个人视频'">{{darenWorksinfo.starWorkReport.pplayMedian?darenWorksinfo.starWorkReport.pplayMedian:"-"}}<i class="rank" v-if="darenInfo.pvideoPlayMedianShowTag">{{darenInfo.pvideoPlayMedianShowTag}}</i></span>
              <span v-show="portraitName1==='聚星视频'">{{darenWorksinfo.starWorkReport.bplayMedian?darenWorksinfo.starWorkReport.bplayMedian:"-"}}<i class="rank" v-if="darenInfo.bvideoPlayMedianShowTag">{{darenInfo.bvideoPlayMedianShowTag}}</i></span>
              <p v-show="portraitName1==='个人视频'">超过<span class="colorRed">{{darenWorksinfo.starWorkReport.pplayMedianExceedRateData?.[daysTab]?fmt(darenWorksinfo.starWorkReport.pplayMedianExceedRateData?.[daysTab]*100):'-'}}%</span>同类型达人</p>
              <p v-show="portraitName1==='聚星视频'">超过<span class="colorRed">{{darenWorksinfo.starWorkReport.bplayMedianExceedRateData?.[daysTab]?fmt(darenWorksinfo.starWorkReport.bplayMedianExceedRateData?.[daysTab]*100):'-'}}%</span>同类型达人</p>
          </li>

      </ul>
      <ul class="summary-wrap">
        <li>
            <p>
              视频数量
              <el-tooltip effect="dark" :content="portraitName1.includes('个人') ? '达人近期已发布至少7天的视频' : '达人近期已结算的视频数量'" placement="bottom">
                <img src="../../../assets/question.png" class="question" alt="">
              </el-tooltip>
            </p>
            <span v-show="portraitName1==='个人视频'">{{darenWorksinfo.starWorkReport.pphotoCntData?.[daysTab]?fmt(darenWorksinfo.starWorkReport.pphotoCntData?.[daysTab],{micrometer: true}):"-"}}</span>
            <span v-show="portraitName1==='聚星视频'">{{darenWorksinfo.starWorkReport.bphotoCntData?.[daysTab]?fmt(darenWorksinfo.starWorkReport.bphotoCntData?.[daysTab],{micrometer: true}):"-"}}</span>
        </li>
        <li>
            <p>
              平均时长
            </p>
            <span v-show="portraitName1==='个人视频'">{{handleDur(darenWorksinfo.starWorkReport.pavgVideoDurationData)}}s</span>
            <span v-show="portraitName1==='聚星视频'">{{handleDur(darenWorksinfo.starWorkReport.bavgVideoDurationData)}}s</span>
        </li>
        <li>
            <p>
              平均点赞
              <el-tooltip effect="dark" :content="portraitName1.includes('个人') ? '达人近期发布的作品平均点赞数，仅统计7日自然流量的数据' : '达人近期已结算的视频平均点赞数，仅统计履约期间自然流量'" placement="bottom">
                <img src="../../../assets/question.png" class="question" alt="">
              </el-tooltip>
            </p>
            <span v-show="portraitName1==='个人视频'">{{darenWorksinfo.starWorkReport.pavgLikeCntData?.[daysTab]?fmt(darenWorksinfo.starWorkReport.pavgLikeCntData?.[daysTab],{micrometer: true}):"-"}}</span>
            <span v-show="portraitName1==='聚星视频'">{{darenWorksinfo.starWorkReport.bavgLikeCntData?.[daysTab]?fmt(darenWorksinfo.starWorkReport.bavgLikeCntData?.[daysTab],{micrometer: true}):"-"}}</span>
        </li>
        <li>
            <p>
              平均评论
              <el-tooltip effect="dark" :content="portraitName1.includes('个人') ? '达人近期发布的作品平均评论数，仅统计7日自然流量的数据' : '达人近期已结算的视频平均评论数，仅统计履约期间自然流量'" placement="bottom">
                <img src="../../../assets/question.png" class="question" alt="">
              </el-tooltip>
            </p>
            <span v-show="portraitName1==='个人视频'">{{darenWorksinfo.starWorkReport.pavgCommentCntData?.[daysTab]?fmt(darenWorksinfo.starWorkReport.pavgCommentCntData?.[daysTab],{micrometer: true}):"-"}}</span>
            <span v-show="portraitName1==='聚星视频'">{{darenWorksinfo.starWorkReport.bavgCommentCntData?.[daysTab]?fmt(darenWorksinfo.starWorkReport.bavgCommentCntData?.[daysTab],{micrometer: true}):"-"}}</span>
        </li>
        <li>
            <p>
              平均分享
              <el-tooltip effect="dark" :content="portraitName1.includes('个人') ? '达人近期发布的作品平均分享数，仅统计7日自然流量的数据' : '达人近期已结算的视频平均分享数，仅统计履约期间自然流量'" placement="bottom">
                <img src="../../../assets/question.png" class="question" alt="">
              </el-tooltip>
            </p>
            <span v-show="portraitName1==='个人视频'">{{darenWorksinfo.starWorkReport.pavgShareCntData?.[daysTab]?fmt(darenWorksinfo.starWorkReport.pavgShareCntData?.[daysTab],{micrometer: true}):"-"}}</span>
            <span v-show="portraitName1==='聚星视频'">{{darenWorksinfo.starWorkReport.bavgShareCntData?.[daysTab]?fmt(darenWorksinfo.starWorkReport.bavgShareCntData?.[daysTab],{micrometer: true}):"-"}}</span>
        </li>
        <li v-if="portraitName1==='聚星视频'">
            <p>
              组件点击率
              <el-tooltip effect="dark" :content="'达人近期已结算的视频中，组件点击转化率，仅统计履约期间自然流量'" placement="bottom">
                <img src="../../../assets/question.png" class="question" alt="">
              </el-tooltip>
            </p>
            <span v-show="portraitName1==='聚星视频'">{{darenWorksinfo.starWorkReport.bavgConversionClickRateData?.[daysTab]?fmt(darenWorksinfo.starWorkReport.bavgConversionClickRateData?.[daysTab]*100,{micrometer: true}):"-"}}%</span>
        </li>
      </ul>
      <p class="tips">
        ·聚星视频包括星视频，个人视频不包括星视频、星任务视频；<br/>
        ·为全面反映达人作品传播表现，数值计算的视频范围包括达人可能已删除或者隐藏的视频，播放量中位数展示自然流量播放量
      </p>
      <div class="top-wrap">
        <!-- top top1 -->
        <h4>波动情况</h4>
        <div>
          <el-radio-group class="tab clear"  v-model="tab2Position" @change="part1Tab2">
            <el-radio-button label="播放量" name="播放量">播放量</el-radio-button>
            <el-radio-button label="点赞量" name="点赞量">点赞量</el-radio-button>
            <el-radio-button label="评论量" name="评论量">评论量</el-radio-button>
            <el-radio-button label="分享量" name="分享量">分享量</el-radio-button>
            <!-- <el-radio-button label="发布频次分布" name="发布频次分布">发布频次分布</el-radio-button> -->
          </el-radio-group>
          <el-radio-group class="tab tab3 clear" v-model="tab3Position" @change="part1Tab3" v-show="tab2Position==='发布频次分布'">
            <el-radio-button label="按月" name="按月">按月</el-radio-button>
            <el-radio-button label="按周" name="按周">按周</el-radio-button>
            <el-radio-button label="按时" name="按时">按时</el-radio-button>
          </el-radio-group>
          <el-radio-group v-model="portraitName2" @change="e=>{expressionTabClick(e,2)}" style="margin-left:10px">
            <el-radio-button label="个人视频">个人视频</el-radio-button>
            <el-radio-button label="聚星视频">聚星视频</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div style="font-size: 12px;color: #8c8c8c;">最近15个视频数据，最高{{tab2Position}}为{{changeChartData?.max || "-"}}，最低为{{changeChartData?.min || "-"}}</div>
      <BarChart2 v-show="tab2Position!=='发布频次分布'" :barChart2Info="videoChartData" ref="videoChart"></BarChart2>
      <BarChart2 v-show="tab2Position==='发布频次分布'" :barChart2Info="publishTimeData" ref="videoChart2"></BarChart2>
      <p class="tips">
        ·聚星视频包括星视频，个人视频不包括星视频、星任务视频，部分达人可能存在删除或隐藏部分视频的情况<br/>
        ·为保护达人经营数据隐私，播放量为当前累计播放量，包括但不限于自然流量播放量等
      </p>
    </div>
    <div v-loading="loadingObj.worksinfo" class="part2">
      <div class="top-wrap">
        <h4>视频内容</h4>
        <div>
          <el-checkbox  v-model="checked">只看电商带货</el-checkbox>
          <el-radio-group v-model="portraitName3" @change="e=>{expressionTabClick(e,3)}" style="margin-left:10px">
            <el-radio-button label="个人视频">个人视频</el-radio-button>
            <el-radio-button label="聚星视频">聚星视频</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <ul class="clear">
        <li v-for="(item,i) in currentPageData" :key="i" v-show="!checked||item.hasSkuInfo">
          <div class="video" liId="0" @click="videoClick(item)" @mouseenter="videoMove" @mouseleave="videoOut">
            <div class="videoWrap"></div>
            <video muted :src="item.url" :vindex="i" :poster="item.coverUrl" preload="none"></video>
          </div>
          <p>{{item.caption}}</p>
          <div class="videobottom">
            <div class="tag">
              <i></i>
              <span>{{item.viewCnt? fmt(item.viewCnt/10000)+"w" : "-"}}</span>
              <!-- <i></i>
              <span>{{item.likeCnt}}</span> -->
              <i></i>
              <span>{{item.commentCnt? fmt(item.commentCnt/10000)+"w" : "-"}}</span>
            </div>
            <div class="releaseTime">发布时间:{{ item.releaseTimeMillis? dayjs(item.releaseTimeMillis).format("YYYY-MM-DD"):'-' }}<el-button type="text" @click="videoClick(item)">详情</el-button></div>
          </div>
        </li>
      </ul>
      <div v-show="!checked" class="pageBox">
        <vxe-pager
          class="pager"
          background
          align="right"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :total="videoListData.length"
          :layouts="['PrevPage', 'Number', 'NextPage']"
          @page-change="setPage"
        ></vxe-pager>
      </div>
      <p v-show="!checked" class="tips">
        ·聚星视频包括星视频，个人视频不包括星视频、星任务视频，部分达人可能存在删除或隐藏部分视频的情况
      </p>
    </div>
    <div v-if="alertShow.isShow" class="alertVideo">
      <div class="close" @click="closeClick"></div>
      <div class="videoCard">
        <div class="videoBox">
          <video autoplay controls loop :src="alertShow.url"></video>
        </div>
        <div class="videoInfo">
          <div class="videoInfoTop">
            <div class="photo"><img :src="darenInfo.headUrl" alt=""></div>
            <div class="name">
              <p> {{darenInfo.name}}</p>
              <i>粉丝数</i><b>{{darenInfo.fansNumber}}</b>
            </div>
          </div>
          <div class="tag">
            <span>{{darenInfo.starTagStr?darenInfo.starTagStr[0]:"-"}}</span>
            <span>{{darenInfo.industryTagStr?darenInfo.industryTagStr[0]:"-"}}</span>
          </div>
          <div class="hr"></div>
          <p> {{alertShow.caption}} </p>
          <div class="other">
            <i></i><b>{{alertShow.viewCnt? fmt(alertShow.viewCnt/10000)+"w" : "-"}}</b>
            <i></i><b>{{alertShow.likeCnt? fmt(alertShow.likeCnt/10000)+"w" : "-"}}</b>
            <i></i><b>{{alertShow.commentCnt? fmt(alertShow.commentCnt/10000)+"w" : "-"}}</b>
          </div>
        </div>
        <div class="bottom">
          <span style="color:black;margin-left:0;margin-right: auto;font-size: 12px;">发布时间：{{ dayjs(alertShow.releaseTimeMillis).format("YYYY-MM-DD HH:mm:ss")}}</span>
          <a :href="alertShow.webpUrl" target="_blank">打开视频</a>
          <i v-clipboard:copy="alertShow.webpUrl" v-clipboard:success="onCopy">复制链接</i>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import tools from "../../../components/tools/tools.js";
import BarChart2 from '../../../components/Echart/BarChart2.vue';
export default {
  name: "Expression",
  props:["darenID"],
  data(){
    return {
      isInit:true,
      portraitName:"个人视频",
      portraitName1:"个人视频",
      portraitName2:"个人视频",
      portraitName3:"个人视频",
      tab2Position:"播放量",
      tab3Position:"按月",
      alertShow:{
        isShow:false,
        src:''
      },
      darenWorksinfo:{
        starWorkReport:{}
      },
      videoChartData:{
        nodeId:'videoChart',//节点
        data: [0],//数据
        xAxisData:['-'],
        yAxisName: '播放量',
        xShow:'false',
        unit:'',
      },
      changeChartData:{
        play:{},
        share:{},
        comment:{},
        like:{},
        max:0,
        min:0,
      },
      changeChartData1:{
        play:{},
        share:{},
        comment:{},
        like:{},
        max:0,
        min:0,
      },
      publishTimeData:{
        nodeId:'videoChart2',//节点
        data: [0],//数据
        xAxisData:['-'],
        yAxisName: '发布数',
        unit:''
      },
      changePublishTimeData:{
        month:{},
        week:{},
        time:{}
      },
      changeListData:{
        myData:[],
        jxData:[]
      },
      darenInfo:{},
      checked:false,
      daysTab: '30',
      videoListData:[],
      currentPageData:[],
      currentPage:1,
      pageSize:4,
      loadingObj: {
       worksinfo: false,
       profile: false,
       videoPlay: false
      }
    }
  },
  computed:{

  },
  filters: {

  },
  methods:{
    setPage(){
      let begin = (this.currentPage - 1) * this.pageSize;
      let end = this.currentPage * this.pageSize;
      this.currentPageData = this.videoListData?.slice(begin, end) || [];
    },
    handleDur(val){
      return val?.[this.daysTab]?.toFixed?.(1)??'-'
    },
    handleNum(val){
      return val?.[this.daysTab]?.toLocaleString?.()??'-'
    },
    expressionTabClick(tab, type){
      this.type = type
      if(tab==="个人视频"){
        this['portraitName'+this.type]==="个人视频"
        if(type==3){
          this.videoListData = this.changeListData.myData
          this.currentPage = 1
          this.setPage()
        }
        if(type==2){
          if(this.tab2Position==="播放量"){
            this.videoChartData = this.changeChartData.play
            this.$refs.videoChart.barChart2(this.changeChartData.play)
            this.changeChartData.max = Math.max(...this.changeChartData.play.data)?this.fmt(Math.max(...this.changeChartData.play.data)/10000)+"w":"-"
            this.changeChartData.min = Math.min(...this.changeChartData.play.data)?this.fmt(Math.min(...this.changeChartData.play.data)/10000)+"w":"-"
          }else if(this.tab2Position==="点赞量"){
            this.videoChartData = this.changeChartData.like
            this.$refs.videoChart.barChart2(this.changeChartData.like)
            this.changeChartData.max = Math.max(...this.changeChartData.like.data)?this.fmt(Math.max(...this.changeChartData.like.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData.like.data)?this.fmt(Math.min(...this.changeChartData.like.data)/10000)+"w":"-"
          }else if(this.tab2Position==="评论量"){
            this.videoChartData = this.changeChartData.comment
            this.$refs.videoChart.barChart2(this.changeChartData.comment)
            this.changeChartData.max = Math.max(...this.changeChartData.comment.data)?this.fmt(Math.max(...this.changeChartData.comment.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData.comment.data)?this.fmt(Math.min(...this.changeChartData.comment.data)/10000)+"w":"-"
          }else if(this.tab2Position==="分享量"){
            this.videoChartData = this.changeChartData.share
            this.$refs.videoChart.barChart2(this.changeChartData.share)
            this.changeChartData.max = Math.max(...this.changeChartData.share.data)?this.fmt(Math.max(...this.changeChartData.share.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData.share.data)?this.fmt(Math.min(...this.changeChartData.share.data)/10000)+"w":"-"
          }
        }
      }else if(tab==="聚星视频"){
        this['portraitName'+this.type]==="聚星视频"
        if(type==3){
          this.videoListData = this.changeListData.jxData
          this.currentPage = 1
          this.setPage()
        }
        if(type==2){
          if(this.tab2Position==="播放量"){
            this.videoChartData = this.changeChartData1.play
            this.$refs.videoChart.barChart2(this.changeChartData1.play)
            this.changeChartData.max = Math.max(...this.changeChartData1.play.data)?this.fmt(Math.max(...this.changeChartData1.play.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData1.play.data)?this.fmt(Math.min(...this.changeChartData1.play.data)/10000)+"w":"-"
          }else if(this.tab2Position==="点赞量"){
            this.videoChartData = this.changeChartData1.like
            this.$refs.videoChart.barChart2(this.changeChartData1.like)
            this.changeChartData.max = Math.max(...this.changeChartData1.like.data)?this.fmt(Math.max(...this.changeChartData1.like.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData1.like.data)?this.fmt(Math.min(...this.changeChartData1.like.data)/10000)+"w":"-"
          }else if(this.tab2Position==="评论量"){
            this.videoChartData = this.changeChartData1.comment
            this.$refs.videoChart.barChart2(this.changeChartData1.comment)
            this.changeChartData.max = Math.max(...this.changeChartData1.comment.data)?this.fmt(Math.max(...this.changeChartData1.comment.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData1.comment.data)?this.fmt(Math.min(...this.changeChartData1.comment.data)/10000)+"w":"-"
          }else if(this.tab2Position==="分享量"){
            this.videoChartData = this.changeChartData1.share
            this.$refs.videoChart.barChart2(this.changeChartData1.share)
            this.changeChartData.max = Math.max(...this.changeChartData1.share.data)?this.fmt(Math.max(...this.changeChartData1.share.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData1.share.data)?this.fmt(Math.min(...this.changeChartData1.share.data)/10000)+"w":"-"
          }
        }
      }

    },
    part1Tab2(tab){
      this.tab2Position=tab
      if(tab==="播放量"){
        if(this.portraitName2=="个人视频"){
          this.videoChartData = this.changeChartData.play
          this.$refs.videoChart.barChart2(this.changeChartData.play)
          this.changeChartData.max = Math.max(...this.changeChartData.play.data)?this.fmt(Math.max(...this.changeChartData.play.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData.play.data)?this.fmt(Math.min(...this.changeChartData.play.data)/10000)+"w":"-"
        }else{
          this.videoChartData = this.changeChartData1.play
          this.$refs.videoChart.barChart2(this.changeChartData1.play)
          this.changeChartData.max = Math.max(...this.changeChartData1.play.data)?this.fmt(Math.max(...this.changeChartData1.play.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData1.play.data)?this.fmt(Math.min(...this.changeChartData1.play.data)/10000)+"w":"-"
        }

      }else if(tab==="点赞量"){
        if(this.portraitName2=="个人视频"){
          this.videoChartData = this.changeChartData.like
          this.$refs.videoChart.barChart2(this.changeChartData.like)
          this.changeChartData.max = Math.max(...this.changeChartData.like.data)?this.fmt(Math.max(...this.changeChartData.like.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData.like.data)?this.fmt(Math.min(...this.changeChartData.like.data)/10000)+"w":"-"
        }else{
          this.videoChartData = this.changeChartData1.like
          this.$refs.videoChart.barChart2(this.changeChartData1.like)
          this.changeChartData.max = Math.max(...this.changeChartData1.like.data)?this.fmt(Math.max(...this.changeChartData1.like.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData1.like.data)?this.fmt(Math.min(...this.changeChartData1.like.data)/10000)+"w":"-"
        }
      }else if(tab==="评论量"){
        if(this.portraitName2=="个人视频"){
          this.videoChartData = this.changeChartData.comment
          this.$refs.videoChart.barChart2(this.changeChartData.comment)
          this.changeChartData.max = Math.max(...this.changeChartData.comment.data)?this.fmt(Math.max(...this.changeChartData.comment.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData.comment.data)?this.fmt(Math.min(...this.changeChartData.comment.data)/10000)+"w":"-"
        }else{
          this.videoChartData = this.changeChartData1.comment
          this.$refs.videoChart.barChart2(this.changeChartData1.comment)
          this.changeChartData.max = Math.max(...this.changeChartData1.comment.data)?this.fmt(Math.max(...this.changeChartData1.comment.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData1.comment.data)?this.fmt(Math.min(...this.changeChartData1.comment.data)/10000)+"w":"-"
        }
      }else if(tab==="分享量"){
        if(this.portraitName2=="个人视频"){
          this.videoChartData = this.changeChartData.share
          this.$refs.videoChart.barChart2(this.changeChartData.share)
          this.changeChartData.max = Math.max(...this.changeChartData.share.data)?this.fmt(Math.max(...this.changeChartData.share.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData.share.data)?this.fmt(Math.min(...this.changeChartData.share.data)/10000)+"w":"-"
        }else{
          this.videoChartData = this.changeChartData1.share
          this.$refs.videoChart.barChart2(this.changeChartData1.share)
          this.changeChartData.max = Math.max(...this.changeChartData1.share.data)?this.fmt(Math.max(...this.changeChartData1.share.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData1.share.data)?this.fmt(Math.min(...this.changeChartData1.share.data)/10000)+"w":"-"
        }
      }
    },
    part1Tab3(tab){
      this.tab3Position=tab
      if(tab==="按月"){
        this.publishTimeData = this.changePublishTimeData.month
        this.$refs.videoChart2.barChart2(this.publishTimeData)
      }else if(tab==="按周"){
        this.publishTimeData = this.changePublishTimeData.week
        this.$refs.videoChart2.barChart2(this.publishTimeData)
      }else if(tab==="按时"){
        this.publishTimeData = this.changePublishTimeData.time
        this.$refs.videoChart2.barChart2(this.publishTimeData)
      }
    },
    initGetWorksinfo(data){
      console.log(data);
      let darenWorksinfo = data
      // part1
      darenWorksinfo.starWorkReport.pcompletePlayRate=tools.scale(darenWorksinfo.starWorkReport.pcompletePlayRateData[this.daysTab])
      darenWorksinfo.starWorkReport.bcompletePlayRate=tools.scale(darenWorksinfo.starWorkReport.bcompletePlayRateData[this.daysTab])
      darenWorksinfo.starWorkReport.pinteractionRate=tools.scale(darenWorksinfo.starWorkReport.pinteractionRateData[this.daysTab])
      darenWorksinfo.starWorkReport.binteractionRate=tools.scale(darenWorksinfo.starWorkReport.binteractionRateData[this.daysTab])
      darenWorksinfo.starWorkReport.pplayMedian=tools.setW(darenWorksinfo.starWorkReport.pplayMedianData[this.daysTab])
      darenWorksinfo.starWorkReport.bplayMedian=tools.setW(darenWorksinfo.starWorkReport.bplayMedianData[this.daysTab])
      this.darenWorksinfo = darenWorksinfo
      // 图表
      let obj={
        play:{
          nodeId:'videoChart',//节点
          data: [],//数据
          xAxisData:[],
          yAxisName: '播放量',
          xShow:'false',
          unit:''
        },
        share:{
          nodeId:'videoChart',//节点
          data: [],//数据
          xAxisData:[],
          yAxisName: '分享量',
          xShow:'false',
          unit:''
        },
        comment:{
          nodeId:'videoChart',//节点
          data: [],//数据
          xAxisData:[],
          yAxisName: '评论量',
          xShow:'false',
          unit:''
        },
        like:{
          nodeId:'videoChart',//节点
          data: [],//数据
          xAxisData:[],
          yAxisName: '点赞量',
          xShow:'false',
          unit:''
        }
      }
      let changeChartData = this._.cloneDeep(obj)
      let changeChartData1 = this._.cloneDeep(obj)
      // darenWorksinfo.personWorks.map(item=>{
      //   changeChartData.play.data.push(item.viewCnt)
      //   changeChartData.play.xAxisData.push(item.caption)

      //   changeChartData.like.data.push(item.likeCnt)
      //   changeChartData.like.xAxisData.push(item.caption)

      //   changeChartData.comment.data.push(item.commentCnt)
      //   changeChartData.comment.xAxisData.push(item.caption)

      //   changeChartData.share.data.push(item.forwardCnt)
      //   changeChartData.share.xAxisData.push(item.caption)
      // })

      // 视频
      let myData=[]
      let jxData=[]
      darenWorksinfo.personWorks.map(item=>{
        myData.push(item)
        //波动数据
        changeChartData.play.data.push(item.viewCnt)
        changeChartData.play.xAxisData.push(item.caption)

        changeChartData.like.data.push(item.likeCnt)
        changeChartData.like.xAxisData.push(item.caption)

        changeChartData.comment.data.push(item.commentCnt)
        changeChartData.comment.xAxisData.push(item.caption)

        changeChartData.share.data.push(item.forwardCnt)
        changeChartData.share.xAxisData.push(item.caption)
      })
      this.changeChartData = changeChartData
      darenWorksinfo.adSocialWorks.map(item=>{
        jxData.push(item)
        //波动数据
        changeChartData1.play.data.push(item.viewCnt)
        changeChartData1.play.xAxisData.push(item.caption)

        changeChartData1.like.data.push(item.likeCnt)
        changeChartData1.like.xAxisData.push(item.caption)

        changeChartData1.comment.data.push(item.commentCnt)
        changeChartData1.comment.xAxisData.push(item.caption)

        changeChartData1.share.data.push(item.forwardCnt)
        changeChartData1.share.xAxisData.push(item.caption)
      })
      this.changeChartData1 = changeChartData1
      this.changeListData = {
        myData,
        jxData
      }
      this.videoListData = myData
      this.setPage()
    },
    initGetKuaishouData(data){
      let darenPublish= data
      let changePublishTimeData ={
        month:{
          nodeId:'videoChart2',//节点
          data: [],//数据
          xAxisData:[],
          yAxisName: '发布数',
          yScale:'false',
          unit:''
        },
        week:{
          nodeId:'videoChart2',//节点
          data: [],//数据
          xAxisData:['周日','周一','周二','周三','周四','周五','周六'],
          yAxisName: '发布数',
          yScale:'false',
          unit:''
        },
        time:{
          nodeId:'videoChart2',//节点
          data: [],//数据
          xAxisData:[],
          yAxisName: '发布数',
          yScale:'false',
          unit:''
        }
      }
      for(let key in darenPublish.starWorkPlayMonthInfo){
        changePublishTimeData.month.xAxisData.push(key+"月")
        changePublishTimeData.month.data.push(darenPublish.starWorkPlayMonthInfo[key])
      }
      for(let key in darenPublish.starWorkPlayWeekInfo){
        changePublishTimeData.week.data.push(darenPublish.starWorkPlayWeekInfo[key])
      }
      for(let key in darenPublish.starWorkPlayHourInfo){
        changePublishTimeData.time.xAxisData.push(key)
        changePublishTimeData.time.data.push(darenPublish.starWorkPlayHourInfo[key])
      }
      this.changePublishTimeData=changePublishTimeData
    },
    videoClick(item){
      this.alertShow = {
        isShow:true,
        ...item
      }
    },
    videoMove(e){
        e.currentTarget.firstElementChild.className="videoWrap active"
        e.currentTarget.lastElementChild.play()
    },
    videoOut(e){
      e.currentTarget.firstElementChild.className="videoWrap"
      e.currentTarget.lastElementChild.pause()
    },
    closeClick(){
      this.alertShow.isShow=false
    },
    onCopy(){
      alert('复制链接成功')
    },
    getWorksinfo(){
      // 达人作品
      if(window.sessionStorage.getItem('getWorksinfo')){
          this.initGetWorksinfo(JSON.parse(window.sessionStorage.getItem('getWorksinfo')).data.data)
          if(this.flag1){
            this.$refs.videoChart?.barChart2(this.changeChartData.play)
          }
          this.changeChartData.max = Math.max(...this.changeChartData.play.data)?this.fmt(Math.max(...this.changeChartData.play.data)/10000)+"w":"-"
          this.changeChartData.min = Math.min(...this.changeChartData.play.data)?this.fmt(Math.min(...this.changeChartData.play.data)/10000)+"w":"-"
      }else{
          this.loadingObj.worksinfo = true
          this.$api.getKuaishouData.getWorksinfo('/'+this.darenID).then((res) => {
            window.sessionStorage.setItem('getWorksinfo',JSON.stringify(res));
            this.initGetWorksinfo(JSON.parse(window.sessionStorage.getItem('getWorksinfo')).data.data)
            this.$refs.videoChart?.barChart2(this.changeChartData.play)
            this.changeChartData.max = Math.max(...this.changeChartData.play.data)?this.fmt(Math.max(...this.changeChartData.play.data)/10000)+"w":"-"
            this.changeChartData.min = Math.min(...this.changeChartData.play.data)?this.fmt(Math.min(...this.changeChartData.play.data)/10000)+"w":"-"
          }).finally(()=>{
            this.loadingObj.worksinfo = false
          })
      }
    },
    stringWtoNum(str){
      console.log('str :>> ', str);
      if(typeof(str)=="string"){
        if(str.split("w")[0]){
          let curStr = str.split("w")[0]
          console.log('curStr :>> ', curStr);
          return curStr? Number(curStr)*1000:0
        }
      }
    }
  },
  components:{
    BarChart2,
  },
  watch:{
    daysTab(){
      this.initGetWorksinfo(JSON.parse(window.sessionStorage.getItem('getWorksinfo')).data.data)
    },
    // portraitName(val){
    //   if(val==="个人视频"){
    //     this.portraitName==="个人视频"
    //     this.videoListData = this.changeListData.myData
    //   }else if(val==="聚星视频"){
    //     this.portraitName==="聚星视频"
    //     this.videoListData = this.changeListData.jxData
    //   }
    // },
  },
  created(){
    this.getWorksinfo()
    // 达人基础数据
    if(window.sessionStorage.getItem('getKsProfile')){
        let darenInfo = JSON.parse(window.sessionStorage.getItem('getKsProfile')).data.data
        darenInfo.fansNumber = tools.setW(darenInfo.fansNumber)
        darenInfo.industryTagStr =darenInfo.industryTagStr?darenInfo.industryTagStr.split(","):""
        darenInfo.starTagStr = darenInfo.starTagStr?darenInfo.starTagStr.split(","):""
        this.darenInfo = darenInfo;
    }else{
        this.loadingObj.profile = true
        this.$api.getKuaishouData.getKsProfile('/'+this.darenID).then((res) => {
            window.sessionStorage.setItem('getKsProfile',JSON.stringify(res));
            let darenInfo = JSON.parse(window.sessionStorage.getItem('getKsProfile')).data.data
            darenInfo.fansNumber = tools.setW(darenInfo.fansNumber)
            darenInfo.industryTagStr =darenInfo.industryTagStr?darenInfo.industryTagStr.split(","):""
            darenInfo.starTagStr = darenInfo.starTagStr?darenInfo.starTagStr.split(","):""
            this.darenInfo = darenInfo;
        }).finally(()=>{
          this.loadingObj.profile = false
        })
    }
    // 发布频次分布
    if(window.sessionStorage.getItem('getKsVideoplay')){
      this.initGetKuaishouData(JSON.parse(window.sessionStorage.getItem('getKsVideoplay')).data.data)
      if(this.flag1){
        this.$refs.videoChart2?.barChart(this.changePublishTimeData.month)
      }
    }else{
      this.loadingObj.videoPlay = true
      this.$api.getKuaishouData.getKsVideoplay('/'+this.darenID).then((res) => {
        window.sessionStorage.setItem('getKsVideoplay',JSON.stringify(res));
        this.initGetKuaishouData(res.data.data)
        this.$refs.videoChart2?.barChart2(this.changePublishTimeData.month)
      }).finally(()=>{
        this.loadingObj.videoPlay = false
      })
    }
  },
  mounted(){
    if(window.sessionStorage.getItem('getWorksinfo')){
      this.$refs.videoChart?.barChart2(this.changeChartData.play)
      this.$refs.videoChart2?.barChart2(this.changePublishTimeData.month)
      this.isInit=false
    }

  }
}
</script>

<style scoped lang="less">
  .colorRed{
    font-size: 12px !important;
    color:#FF5C00 !important;
  }
  .active{
    display: none;
  }
  i{
    font-style: normal;
  }
  li{
      padding:0;
      margin:0;
      list-style:none;
  }
  .hr{
    width: 100%;
    height: 1px;
    background: #eee;
  }
  #videoChart{
    margin-top: 10px;
    width: 100%;
    height: 266px;
  }
  #videoChart2{
    margin-top: 10px;
    width: 100%;
    height: 266px;
  }
  .ExpressionContainer{
    width: 884px;
  }
  .ExpressionContainer .part1{
    width: 964px;
    padding: 0 30px;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
  }
  .top-wrap{
    display: flex;
    align-items: center;
    justify-content: space-between;
    h5{
      display: inline-block;
      font-size: 16px;
      font-family: OPPOSans;
      font-weight: 500;
      color: #333333;
    }
  }
  .summary-wrap{
    display: flex;
    justify-content: space-around;
    >li{
      float: none !important;
      width: unset !important;
      text-align: center;
      border: none !important;
    }
  }
  .ExpressionContainer .top{
    width: 100%;
    height: 76px;
    box-sizing: border-box;
    border-bottom: 1px solid #F0F0F0;
    display: flex;
    align-items: center;
  }
  .ExpressionContainer .top h5{
    display: inline-block;
    height: 76px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .ExpressionContainer .top i{
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #999999;
  }
  .ExpressionContainer .top .tab{
    float: left;
    margin-left: 16px;
    margin-top: 22px;
  }
  .ExpressionContainer .top .tab.tab3{
    float: right;
  }
  .ExpressionContainer .part1 ul{
      width: 100%;
      height: 120px;
      margin: 0;
      padding: 30px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #F0F0F0;
  }
  .ExpressionContainer .part1 ul li{
      float: left;
      width: 20%;
      height: 100%;
      border-right: 1px solid #F0F0F0;
      list-style:none;
      text-align: center;
      box-sizing: border-box;
  }
  .ExpressionContainer .part1 ul:nth-of-type(1){
    height: 136px;
  }
  .ExpressionContainer .part1 ul:nth-of-type(1) li{
      width: 33%;
      height: 78px;
  }
  .ExpressionContainer .part1 ul li:nth-last-of-type(1){
      border: 0;
  }
  .ExpressionContainer .part1 ul li span{
      display: inline-block;
      margin-bottom: 6px;
      font-size: 18px;
      font-family: OPPOSans;
      font-weight: bold;
      color: #333333;
  }
  .ExpressionContainer .part1 ul li p u{
    text-decoration: none;
    color: #FF5C00;
  }
  .ExpressionContainer .part1 ul li p{
      position: relative;
      margin-top: 4px;
      font-size: 12px;
      font-family: OPPOSans;
      font-weight: 400;
      color: #666666;
      text-align: center;
  }
  .ExpressionContainer .part1 ul li p i{
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      margin-left: 6px;
      width: 14px;
      height: 14px;
  }
  .ExpressionContainer .part1 ul li .rank{
    display: inline-block;
    width: 34px;
    background: #F6F6F6;;
    text-align: center;
    border-radius: 4px;
    font-size: 12px;
    color: #666666;
  }
  .ExpressionContainer .top1.top{
    border-bottom: 0;
  }
  .ExpressionContainer .top1.top h5{
    float: left;
    height: 100%;
    margin: 0;
    font-size: 14px;
    line-height: 76px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
    bottom: 0;
  }

  .ExpressionContainer /deep/ .el-tabs__content{
    margin-top: 0;
  }
  .ExpressionContainer /deep/ .el-tabs__nav-wrap::after{
    height: 0;
  }
  .ExpressionContainer /deep/ .el-tabs__nav-scroll{
    padding-left: 30px;
  }
  .ExpressionContainer{
    width: 100%;
    background: #FFFFFF;
    border-radius: 4px;
  }
  .ExpressionContainer /deep/ .el-tabs__item{
    line-height:74px;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .ExpressionContainer /deep/ .el-tabs__active-bar{
    background:transparent!important;
  }
  .ExpressionContainer /deep/ .el-tabs__active-bar {
    height: 0!important;
  }
  .ExpressionContainer .top1 .topLeft{
    float: left;
    width: 60%;
  }
  .ExpressionContainer .top1 .topLeft p{
    height: 10px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .ExpressionContainer .top1 .topLeft span{
    display: inline-block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #999;
  }
  .ExpressionContainer .top1 .topLeft i{
    display: inline-block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
    margin-right: 18px;
    margin-left: 6px;
  }
  .ExpressionContainer .part2{
    width: 100%;
    padding: 0 30px 20px 30px;
    background: #FFFFFF;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .ExpressionContainer .part2 h5{
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .ExpressionContainer .part2 ul{
    width: 100%;
    padding: 0;
    overflow: hidden;
  }
  .ExpressionContainer .part2 ul li{
    position: relative;
    float: left;
    width: 200px;
    height: 426px;
    // margin-right: 30px;
    margin: 0 16px 24px 0
  }
  .ExpressionContainer .part2 ul li .video{
    position: relative;
    width: 200px;
    height: 342px;
    background: #000000;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
  }
  .ExpressionContainer .part2 ul li .video video{
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 100%;
  }
  .ExpressionContainer .part2 ul li .video .videoWrap{
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    // background:linear-gradient(rgba(0,0,0,0),rgba(0,0,0,.6))
  }
  .ExpressionContainer .part2 ul li .video .videoWrap::after{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 1;
    content: '';
    width: 31px;
    height: 35px;
    background: url("../images/icon_play.png") no-repeat center;
  }

  .ExpressionContainer .part2 ul li p{
    position: absolute;
    left: 12px;
    bottom: 80px;
    font-size: 14px;
    width: 176px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: OPPOSans;
    font-weight: 600;
    color: #fff;
    line-height: 22px;
    display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
  }
  .ExpressionContainer .part2 ul li .tag i{
    display: inline-block;
    width: 11px;
    height: 11px;
    margin-right: 8px;
    background: url("../images/icon_1.png") no-repeat center;
  }
  .ExpressionContainer .part2 ul li .tag i:nth-of-type(1){
    width: 8px;
    height: 11px;
    background-image: url("../images/icon_3.png");
  }
  .ExpressionContainer .part2 ul li .tag i:nth-of-type(3){
    background-image: url("../images/icon_2.png");
  }
  .ExpressionContainer .part2 ul li .tag span{
    margin-right: 12px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #666666;
  }
  .videobottom{
    padding: 12px;
    background-color: #f5f7f9;
  }
  .releaseTime{
    font-size: 12px;
    color: #8c8c8c;
    line-height: 20px;
  }
  .pageBox{
    margin: 0 auto;
    padding: 10px;
    /deep/ .pager>div{
      text-align: right;
    }
  }
  .tips{
    padding: 8px 16px;
    background: #fbfbfb;
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    color: #8c8c8c;
  }
  .alertVideo{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    background: rgba(0,0,0,.5);
  }
  .alertVideo .videoCard{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    padding: 8px;
    width: 820px;
    height: 646px;
    background: #fff;
    border-radius: 6px;
  }
  .alertVideo .videoCard .videoBox{
    position: relative;
    float: left;
    width: 363px;
    height: 644px;
    border-radius: 4px;
    overflow: hidden;
    background: #000000;
  }
  .alertVideo .videoCard .videoBox video{
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 100%;
  }
  .alertVideo .videoCard .videoInfo{
    float: right;
    width: 390px;
    height: 100%;
    margin-right: 20px;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop{
    margin-top: 30px;
    overflow: hidden;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .photo{
    float: left;
    width: 60px;
    height: 60px;
    margin-top: 14px;
    margin-right: 18px;
    border-radius: 50%;
    box-sizing: border-box;
    overflow: hidden;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .photo img{
    width: 100%;
    height: 100%;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name{
    float: left;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name p{
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 0;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name i{
    display: inline-block;
    margin-right: 6px;
    color: #999;
    font-size: 14px;

  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name b{
    display: inline-block;
    color: #666;
    font-size: 14px;
  }
  .alertVideo .videoCard .videoInfo .tag{
    margin: 40px 0;
    overflow: hidden;
  }
  .alertVideo .videoCard .videoInfo .tag span{
    float: left;
    color: #333;
    font-size: 14px;
    padding: 3px 8px;
    background: #eee;
    border-radius: 4px;
    margin-right: 8px;
  }
  .alertVideo .videoCard .videoInfo p{
    width: 100%;
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #333;
  }
  .alertVideo .videoCard .videoInfo .other{
    width: 100%;
  }
  .alertVideo .videoCard .videoInfo .other i{
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 10px;
    line-height: 18px;
    background: url("../images/icon_1.png") no-repeat center bottom;
  }
  .alertVideo .videoCard .videoInfo .other i:nth-of-type(1){
    background-image: url("../images/icon_3.png");
  }
  .alertVideo .videoCard .videoInfo .other i:nth-of-type(3){
    background-image: url("../images/icon_2.png");
  }
  .alertVideo .videoCard .videoInfo .other b{
    display: inline-block;
    margin-right: 20px;
    font-size: 16px;
    color: #333;
    line-height: 18px;
  }
  .alertVideo .close{
    position: absolute;
    top:40px;
    right: 40px;
    width: 21px;
    height: 21px;
    background: url("../images/close.png") no-repeat center;
    cursor: pointer;
  }
  .videoCard .bottom{
    position: absolute;
    bottom: 20px;
    right: 30px;
    display: flex;
    width: 390px;
    align-items: center;
  }
  .videoCard .bottom a,
  .videoCard .bottom i{
    display: inline-block;
    margin-left: 10px;
    color: #38a1ff;
    font-size: 12px;
    cursor: pointer;
  }
</style>